import React from "react";
import PropTypes from "prop-types";
import config from "../../utils/config";

import get from "lodash/get";

const _ = { get };

const Image = (props) => {
  let { alt, style, height, width, elements } = props; 
  return (
    <div className="moderationImg" onClick={props.openClick}>
      <img
        src={`${config.imageBaseUrl}${props.item}`}
        className="w-100"
        style={style}
        alt={alt}
        height={height}
        width={width}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = `${config.imageBaseUrl}/content/dam/re-platform-images/Dashboard/404.jpg`;
        }}
      />
      <div className="higilightBox">
        <span className="">
          {props.category === "ride"
            ? props.categoryInfo &&
              props.categoryInfo.categoryId &&
              props.categoryInfo.categoryId.rideName
            : props.categoryInfo &&
              props.categoryInfo.categoryId &&
              props.categoryInfo.categoryId.eventName}
        </span>
        <span className="">
          {props.category === "ride"
            ? props.categoryInfo &&
              props.categoryInfo.categoryId &&
              props.categoryInfo.categoryId.rideInfo &&
              props.categoryInfo.categoryId.rideInfo.country
            : props.categoryInfo &&
              props.categoryInfo.categoryId &&
              props.categoryInfo.categoryId.eventInfo &&
              props.categoryInfo.categoryId.eventInfo.country}
        </span>
      </div>
      <div className="overlay d-flex align-items-center justify-content-center">
        <p className="previewText">
          {_.get(
            elements,
            "imageModerationListingFilterElements.previewLabelElement",
            "Preview"
          )}
        </p>
      </div>
    </div>
  );
};

export default Image;

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
};
